import $ from 'jquery';
import { createApp } from 'vue';
import TextpicModal from './components/TextpicModal.vue';

const $app = $('#textpic-modal-vue');

createApp(TextpicModal).mount($app);
